import styled, { css } from 'styled-components';

import { device } from '@/styles/helpers';

interface ScHeaderProps {
  isFixedHeader: boolean;
  withBg?: boolean;
  wide?: boolean;
  $popupHeight: number;
}

export const ScHeader = styled.div<ScHeaderProps>`
  width: 100%;
  z-index: 23;
  border-radius: 0px 0px 24px 24px;

  &:before {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: ${({ theme }) => theme.blackColor};
    z-index: -1;
    border-radius: 0;
    opacity: ${({ wide, withBg }) => (wide || withBg ? 1 : 0)};
    box-shadow: ${({ wide, withBg }) =>
      wide || withBg ? '0px -8px 8px 12px rgb(0 0 0 / 30%)' : ''};
  }

  & > div {
    padding: 8px 8px 8px 16px;
    position: ${({ wide }) => (wide ? 'static' : 'relative')};

    &:before {
      content: "";
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background-color: ${({ theme }) => theme.blackColor};
      border-radius: 74px;
      z-index: -1;
    }
  }

  ${({ isFixedHeader, wide, $popupHeight }) =>
    isFixedHeader
      ? css`
          top: 0;
          position: fixed;
          left: 50%;
          transform: translateX(-50%);
          padding-top: ${
            $popupHeight > 0
              ? wide
                ? `${$popupHeight}px`
                : `${$popupHeight + 8}px`
              : '8px'
          };
          transition: padding-top 0.3s;
        `
      : css`
          position: sticky;
          top: ${$popupHeight > 0 ? (wide ? `${$popupHeight}px` : '8px') : 0};
          transition: top 0.3s;
          margin-bottom: 32px;

          &:before {
            box-shadow: 0px 0px 10px 8px rgb(0 0 0 / 40%),
              0px 0px 20px 8px rgb(0 0 0 / 40%);
          }
        `}

  @media (${device.mobile}) {
    top: ${({ wide, $popupHeight }) => {
      if (!$popupHeight) return 0;
      if (wide) return `${$popupHeight}px`;
      return `${$popupHeight + 8}px`;
    }};
    padding-top: 1px;
    background-color: ${({ theme, withBg }) =>
      withBg ? theme.blackColor : 'transparent'};

    &:before {
      border-radius: 0px 0px 24px 24px;
    }

    & > div {
      padding: 8px;

      &:before {
        content: none;
      }
    }
  }
`;

export const ScHeaderDesktop = styled(ScHeader)`
  display: block;

  @media (${device.tablet}) {
    display: none;
  }
`;

export const ScHeaderMobile = styled(ScHeader)`
  display: none;

  @media (${device.tablet}) {
    display: block;
  }
`;

export const ScHeaderRow = styled.div`
  pointer-events: auto;
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 4px;
  width: calc(100% - 16px);
  position: relative;
  margin: 0 auto;
`;

export const ScHeaderRowMob = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  align-items: center;
  gap: 16px;
  justify-content: space-between;

  & > .reg-btns {
    width: 100%;
    display: flex;
    gap: 8px;
  }

  & > .panel {
    display: flex;
    gap: 8px;
    align-items: center;
  }
`;

export const ScHeaderColLeft = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  justify-content: flex-start;
  align-items: center;
`;

export const ScHeaderColRight = styled.div``;

export const ScHeaderColAccountBlock = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  justify-content: flex-start;
  align-items: center;

  & > * {
    margin-right: 16px;

    &:last-child {
      margin-right: 0px;
    }
  }

  @media (${device.mobile}) {
    width: 100%;
    margin-top: 16px;
  }
`;

export const ScHeaderLogo = styled.div`
  & > a {
    max-width: 140px;
    width: fit-content;
    height: 40px;
    display: block;
    place-content: center;

    > img {
      object-fit: cover;
    }

    @media (${device.mobile}) {
      max-width: 48px;
      > img {
        object-fit: contain;
      }
    }
  }
`;

export const ScHeaderButtonsGroup = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  justify-content: flex-start;
  align-items: center;
  gap: 8px;
`;

export const ScAddons = styled.div`
  position: relative;
  z-index: 15;
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  justify-content: center;
  align-items: center;
`;
